app.service('productPriceTabs', function (store) {

	let $tabs, $tabPanel, $productUpselling;

	function init(props) {
		$tabs = props.$el.find('.price-tab');
		$tabPanel = props.$el.find('.price-tab-panel');
		$productUpselling = props.$el;

		setActivePriceTab();
		setActiveTabPanel();
		setEvents();
	}

	function setActivePriceTab() {
		let $activePriceTab = $tabs.filter(`[data-context=${store.data.isInstalment ? 'instalment' : 'standard'}]`);
		$productUpselling.addClass(!store.data.isInstalment ? 'standard' : 'instalment');
		$activePriceTab.addClass('is-active');
		$tabs.not($activePriceTab).removeClass('is-active');
	}

	function setActiveTabPanel() {
		const isStandardContext = !store.data.isInstalment;
		if (isStandardContext) {
			$tabPanel.not('.promotion-price-date, .historical-price, .omnibus-price-box').toggleClass('is-active');
		}
	}

	function setEvents() {
		$tabs.parent().on('click', '.price-tab', handlePriceTabClick);
	}

	function handlePriceTabClick(e) {
		e.preventDefault();

		if ($(this).hasClass('is-active')) return;
		if ($(this).hasClass('price-instalment-only-shop-tab')) return;
		

		if ($(this).data('context') === 'standard') {
			$productUpselling.removeClass('instalment');
			store.dispatch('setStandardContext');
		} else {
			$productUpselling.removeClass('standard');
			if (store.data.isOutlet) {
				store.dispatch('setDefaultOutletContext', {
					outletCategoryId: store.data.outletCategoryId
				});
			} else {
				store.dispatch('setDefaultContext');
			}
		}

		const context = this.dataset.context === 'standard' ? 'Zakladka_jednorazowa' : 'Zakladka_raty';
		UA.interaction('KP_Crossell', context, 'Kliknięcie');
	}

	return {
		init
	};
});